import { ArrowUpIcon, ArrowDownIcon } from '@heroicons/react/24/solid';
import './Card.css';

/**
 * Card — conteneur de base avec ombre et bordure
 * @param {string} variant  - 'default' | 'flat' | 'raised'
 * @param {bool}   hoverable - ajoute l'effet de survol
 */
const Card = ({ children, padding, variant = 'default', hoverable = false, className = '', style }) => (
  <div
    className={[
      'card',
      `card--${variant}`,
      hoverable ? 'card--hoverable' : '',
      className,
    ].filter(Boolean).join(' ')}
    style={{ ...(padding ? { padding } : {}), ...style }}
  >
    {children}
  </div>
);

/**
 * StatCard — carte KPI avec icône, valeur, label et tendance
 *
 * @param {string} label    - libellé de la métrique
 * @param {string} value    - valeur affichée
 * @param {node}   icon     - icône (FontAwesome class ou composant)
 * @param {string} color    - 'blue' | 'green' | 'purple' | 'amber' | 'cyan' | 'rose' | 'indigo'
 * @param {number} trend    - pourcentage de variation (positif/négatif/null)
 * @param {string} footer   - texte optionnel sous la valeur
 * @param {func}   onClick
 */
const StatCard = ({
  label,
  value,
  icon,
  color     = 'blue',
  trend,
  footer,
  onClick,
  className = '',
}) => {
  const trendPositive = trend > 0;
  const trendNeutral  = trend === 0 || trend == null;

  return (
    <div
      className={[
        'stat-card',
        `stat-card--${color}`,
        onClick ? 'stat-card--clickable' : '',
        className,
      ].filter(Boolean).join(' ')}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      <div className="stat-card__header">
        <span className="stat-card__label">{label}</span>
        {icon && <div className="stat-card__icon">{icon}</div>}
      </div>

      <div className="stat-card__value">{value}</div>

      <div className="stat-card__footer">
        {!trendNeutral && (
          <span className={`stat-card__trend stat-card__trend--${trendPositive ? 'up' : 'down'}`}>
            {trendPositive
              ? <ArrowUpIcon style={{ width: 18, height: 18, flexShrink: 0 }} />
              : <ArrowDownIcon style={{ width: 18, height: 18, flexShrink: 0 }} />
            }
            {Math.abs(trend)}%
          </span>
        )}
        {footer && <span className="stat-card__footer-text">{footer}</span>}
      </div>
    </div>
  );
};

export { StatCard };
export default Card;
